export default {
  EMAIL_SUPPORT: "support@fryd.app",
  SHOP_URL: "https://shop.fryd.app",
  WEBSITE_URL: "https://fryd.app/lexikon",
};
